import {Api} from './api'

export class WidgetContentItemsApi extends Api {

    constructor(apiKey: string) {
        super(apiKey);
    }

    async fetchContentItems(projectId: number, payload: Object): Promise<any> {

        const queryString = new URLSearchParams(payload as Record<string, string>).toString();
        const response = await fetch(`${this.baseUrl}/projects/${projectId}/content-items/widget-hierarchy?${queryString}`, {
            method: 'GET',
            headers: this.getHeaders()
        });

        return this.handleResponse(response);
    }
}
